import Individual from './Individual';
import OrgAssessment from './OrgAssessment';

export default [OrgAssessment, Individual];
